'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.silentRefresher = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OLD_TOKEN = window.localStorage.getItem('test');

var REFRESH_URI = 'https://oauth.motivate.nl/oauth2/auth' + '?client_id=' + process.env.VUE_APP_CLIENT_ID + '&response_type=token' + '&state=' + csrfRandom() + '&redirect_uri=' + encodeURIComponent(process.env.VUE_APP_REDIRECT_URI);

function csrfRandom() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 8; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }return text;
}

function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function getTokenRefresh() {
  //  closeWin();
    var frame = document.createElement('iframe');
    frame.setAttribute('id', 'auth-frame');
    frame.setAttribute('SameSite', 'None');
    frame.setAttribute('aria-hidden', 'true');
    // frame.style.visibility = 'hidden'
    frame.style.position = 'fixed';
    frame.style.width = frame.style.height = frame.borderWidth = '0';
    frame.style.top = '-999';
    var attachedFrame = document.getElementsByTagName('body')[0].appendChild(frame);
    runIframeNavigation(attachedFrame, REFRESH_URI);
    return 'tried';
}

function runIframeNavigation(iframe, url) {
    var counter = 0;
    return new Promise(function (resolve) {
        iframe.onload = function (loadEvent) {
            var cache = [];
            var check = JSON.parse(JSON.stringify(loadEvent.target.contentDocument, function (key, value) {
                if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
                    if (cache.indexOf(value) !== -1) {
                        // Duplicate reference found
                        try {
                            // If this value does not reference a parent it can be deduped
                            return JSON.parse(JSON.stringify(value));
                        } catch (error) {
                            // discard key if value cannot be deduped
                            return;
                        }
                    }
                    // Store value in our collection
                    cache.push(value);
                }
                return value;
            }));

            do {
                counter++;
                if (check) {
                    cache = null; // Enable garbage collection
                    resolve(loadEvent);
                }
            } while (!check && counter < 5000);
            resolve(null);
        };

        iframe.setAttribute('src', url);
    });
}

function getParameters(url) {
    //Params obj
    var params = {};
    //To lowercase
    // url = url.toLowerCase();
    //To array
    url = url.split('&');

    //Iterate over url parameters array
    var length = url.length;
    for (var i = 0; i < length; i++) {
        //Create prop
        var prop = url[i].slice(0, url[i].search('='));
        //Create Val
        var value = url[i].slice(url[i].search('=')).replace('=', '');
        //Params New Attr
        params[prop] = value;
    }

    return params;
}

function closeWin() {
    var someIframe = window.parent.document.getElementById('auth-frame');
    if (someIframe) {
        someIframe.parentNode.removeChild(window.parent.document.getElementById('auth-frame'));
    }
}

function refreshTokenAndCloseIframe(store, APICLIENTS) {
    checker();
    if (OLD_TOKEN != window.localStorage.getItem('m-oauth-token')) {
        OLD_TOKEN = window.localStorage.getItem('m-oauth-token');
        _.each(APICLIENTS, function (client) {
            client.defaults.headers.Authorization = "Bearer " + OLD_TOKEN;
        });
        store.commit('setOauthToken', OLD_TOKEN);
        window.localStorage.setItem('m-oauth-token', OLD_TOKEN);

        closeWin();
    }
    getTokenRefresh();
}

var checker = function checker() {
    if (inIframe()) {
        var token = getParameters(window.location.hash.substr(1));
        window.localStorage.setItem('m-oauth-token', token.access_token);
    }
};

var silentRefresher = function silentRefresher(store, APICLIENTS) {
    setInterval(function () {
        refreshTokenAndCloseIframe(store, APICLIENTS);
    }, 300000);
};
// export {refresher,checker, silentRefresher}
exports.silentRefresher = silentRefresher;